export enum EpisodeStatusEnum {
    iniciado = 1,
    evadido = 2,
    finalizadoAlta = 3,
    finalizadoObito = 4,
    finalizadoInternar = 5,
    finalizadoEvasao = 6,
    finalizadoAltaAdministrativa = 7,
}